import { Basic } from '../basic.js';
/**
 * @class MSVideo
 * @extends Basic
 * @classdesc Видео
 */
export class MSVideo extends Basic {

    static get observedAttributes() {
        return super.observedAttributes.concat([
            'autoplay'
        ]);
    }

    setautoplay(value) {
        this._autoplay = this._toBool(value);
        this._video.autoplay = this._autoplay;
        this.checkforVideo();
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = `
            <video controls style="width:100%;height:100%;object-fit:fill;">
        `;

        const control = this;
        const vid = shadowRoot.querySelector('video');
        vid.onloadeddata = function () {

        };

        this._video = vid;

        this.setautoplay(this.getAttribute("autoplay"));
    }

    checkforVideo() {
        if(this.b){
            clearInterval(this.b)
        }
        //Every 500ms, check if the video element has loaded
        this.b = setInterval(() => {
            if (this._video && this._video.readyState >= 3) {
                //This block of code is triggered when the video is loaded

                //your code goes here
                if (this.autoplay) {
                    this._video.muted = true;
                    this._video.play();
                } else {
                    this._video.pause();
                }

                //stop checking every half second
                clearInterval(this.b);

            }
        }, 500);
    }

    get autoplay() {
        return this._autoplay;
    }

    set autoplay(value) {
        this.setautoplay(value);
    }

    play() {
        this._video.play();
    }

    pause() {
        this._video.pause();
    }



    /**
     * Имя ресурса для изображения фона
     * @type {string}
     */
    get resource() {
        return this._resource;
    }
    set resource(value) {
        this._resource = this.getResourceFromList(value);
        this._video.autoplay = this._autoplay;
        this._video.src = `resources/${this._resource}`;
        this._video.load();
        this.checkforVideo();
    }

    disconnectedCallback(){
        clearInterval(this.b)
        super.disconnectedCallback();
    }
}